// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__lz4iH","footer":"ModalInfo_footer__17TOj"};